





























import { createComponent, computed } from "@vue/composition-api";
import {
  BaseMultiSelect,
  BaseMultiSelectItem,
  BasePrimaryButton
} from "@web-components";

interface DrinkFreeDaysPanelProps {
  availableDrinkFreeDays: number[];
  value: number[];
}

import { daysOfWeekText } from "@dcc/types/dayOfWeek";
import { useDictionary } from "../views/compositions/useDictionary";
export default createComponent({
  props: {
    value: Array as () => number[],
    availableDrinkFreeDays: Array as () => number[]
  },
  components: {
    BaseMultiSelect,
    BaseMultiSelectItem,
    BasePrimaryButton
  },
  setup(props: Readonly<DrinkFreeDaysPanelProps>, { emit }) {
    const dictionary = useDictionary();
    const localDrinkFreeDays = computed({
      get: () => {
        return props.value;
      },
      set: val => {
        emit("input", val);
      }
    });

    const drinkFreeDaysText = computed(() => {
      const newProps = Object.entries(daysOfWeekText).filter(value => {
        const [key] = value;
        return props.availableDrinkFreeDays.includes(Number(key));
      });
      return Object.fromEntries(newProps);
    });

    const disableButton = computed(() => localDrinkFreeDays.value.length <= 0);

    return {
      drinkFreeDaysText,
      localDrinkFreeDays,
      disableButton,
      ...dictionary
    };
  }
});
